/**
 * Auth App Theme
 *
 * Simplified MUI theme for auth pages that doesn't require breakpoint/mode context
 */
import { createTheme } from "@mui/material/styles";

// CK Brand Colors matching auth-pages.css
const BRAND_COLORS = {
  primary: "#233E50",
  primaryHover: "#162B37",
  gradientStart: "#365D76",
  gradientMiddle: "#233E50",
  gradientEnd: "#162B37",
  link: "#2B6574",
  linkHover: "#1a4a56",
  text: {
    primary: "#1F2937",
    secondary: "#6C737F",
  },
  border: "#E5E7EB",
  inputBorder: "#9CA3AF",
  inputFocus: "#2B6574",
};

export const theme = createTheme({
  palette: {
    primary: {
      main: BRAND_COLORS.primary,
      dark: BRAND_COLORS.primaryHover,
    },
    text: {
      primary: BRAND_COLORS.text.primary,
      secondary: BRAND_COLORS.text.secondary,
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily:
      "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: "1.5rem",
    },
    body1: {
      fontSize: "0.9375rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: "100%",
        },
        body: {
          height: "100%",
          margin: 0,
          padding: 0,
        },
        "#auth-root": {
          height: "100%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(35, 62, 80, 0.3)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "medium",
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: BRAND_COLORS.link,
          textDecoration: "none",
          "&:hover": {
            color: BRAND_COLORS.linkHover,
            textDecoration: "underline",
          },
        },
      },
    },
  },
});
